var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.signOut}},[_c('v-icon',{attrs:{"title":"Sign Out","color":"primary","dense":"","left":""}},[_vm._v("mdi-logout")]),_c('span',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.userName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }